var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 8.25C11.625 9.69975 10.4497 10.875 9 10.875C7.55025 10.875 6.375 9.69975 6.375 8.25C6.375 6.80025 7.55025 5.625 9 5.625C10.4497 5.625 11.625 6.80025 11.625 8.25Z",
    stroke: "#1CA8CB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C12.653 1.5 15.75 4.52474 15.75 8.19435C15.75 11.9224 12.6025 14.5385 9.69525 16.3175C9.48338 16.4372 9.24375 16.5 9 16.5C8.75625 16.5 8.51662 16.4372 8.30475 16.3175C5.40292 14.5212 2.25 11.9353 2.25 8.19435C2.25 4.52474 5.34708 1.5 9 1.5Z",
    stroke: "#1CA8CB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDot);
export default __webpack_public_path__ + "static/media/location-dot.41c3443ea4241ea8551fbfdff695e1ab.svg";
export { ForwardRef as ReactComponent };